import type { SearchServiceConfigMessages } from '../../models'

export const SEARCH_SERVICE_CONFIG_MESSAGES_EN: SearchServiceConfigMessages = {
  label: 'Search',
  description: 'Configure the setup for the Search microservice.',
  documentationText: 'For more information on how to structure the JSON files, see {link}',
  documentationLinkText: 'Configure the search microservice.',
  managerIntroText: 'To have a better experience configuring client, click on the following link',
  managerLinkText: 'Search Configuration Manager',
  managerBadgeText: 'New!',
  fields: {
    clientConfig: {
      label: 'Client configuration',
      description: 'Initial configuration of the customer in JSON format',
    },
    endpointConfigs: {
      label: 'Endpoint configuration',
      description: 'Configuration of the endpoints for the customer in JSON format',
    },
    featureConfigs: {
      label: 'Feature configuration',
      description: 'Configuration of the features to be used in JSON format',
    },
  },
}

export const SEARCH_SERVICE_CONFIG_MESSAGES_ES: SearchServiceConfigMessages = {
  label: 'Search',
  description: 'Establece la configuración para el microservicio Search.',
  documentationText:
    'Para más información sobre cómo estructurar los archivos JSON, consulta {link} (información disponible solo en inglés)',
  documentationLinkText: 'Configure the search microservice.',
  managerIntroText: 'To have a better experience configuring client, click on the following link',
  managerLinkText: 'Search Configuration Manager',
  managerBadgeText: 'New!',
  fields: {
    clientConfig: {
      label: 'Configuración del cliente',
      description: 'Configuración inicial, en formato JSON, del cliente',
    },
    endpointConfigs: {
      label: 'Configuración de los endpoint',
      description: 'Configuración, en formato JSON, de los endpoint para el cliente',
    },
    featureConfigs: {
      label: 'Configuración de las funcionalidades',
      description: 'Configuración, en formato JSON, de las funcionalidades a usar',
    },
  },
}
